/**
 * @namespace InternalSearch
 * @aka PIANO.InternalSearch
 */
PIANO.InternalSearch = function (window, document) {

  var _isSearchPage = function _isSearchPage() {
    return ('search' === PIANO.Utils.getPageInformation('objekttyp'));
  };

  var _getSearchData = function _getSearchData() {
    var data = {
      ise_page: 0
    };

    if (0 < document.querySelectorAll('.suchseite .row article').length) {
      data.ise_page = 1;
    }

    var searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('swx_restriction') && '' !== searchParams.get('swx_restriction')) {
      var hasSearchResultWithinRestriction = document.querySelector('.suchseite').querySelectorAll('.row article').length > 0;
      data.ise_page_restriction = hasSearchResultWithinRestriction ? 1 : 0;
    }

    searchParams.forEach(function (value, key) {
      switch (key) {
        case 'swx_q':
        case 'swx_ps_q':
          data.ise_keyword = searchParams.get(key);
          break;
        case 'swx_schoolsubjects':
          data.ise_schoolsubjects = searchParams.getAll(key);
          break;
        case 'swx_mediatypes':
          data.ise_mediatypes = searchParams.getAll(key);
          break;
        case 'swx_yoa':
          data.ise_yoa = searchParams.getAll(key);
          break;
        case 'swx_schoolclassesfrom':
          data.ise_schoolclassesfrom = parseInt(searchParams.get(key), 10);
          break;
        case 'swx_schoolclassesto':
          data.ise_schoolclassesto = parseInt(searchParams.get(key), 10);
          break;
      }
    });

    return data;
  }

  var _trackDisplay = function _trackDisplay() {
    if (!PIANO.Utils.isEnabled() || !_isSearchPage()) {
      return;
    }

    var data = _getSearchData();

    console.debug('Tracking Piano InternalSearchResult Display', data);
    _paq.push(['sendEvent', 'internal_search_result.display', data]);
  }

  document.addEventListener('piano:pushstate', _trackDisplay);
  document.addEventListener('piano:pageview', _trackDisplay);

  return {
    isSearchPage: _isSearchPage,
    getSearchData: _getSearchData
  };

}(window, document);
